import { React, useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import PageWrapper from "../PageWrapper";
import ShowcaseContainer from "./ShowcaseContainer";
import ModalCreateShowcase from "../../components/Modal/ModalCreateShowcase";
import ModalAddPost from "../../components/Modal/ModalAddPost";
import MyValuesCompetencis from "./ValuesandCompetencies";
import Swal from "sweetalert2";
import {
  getShowcases,
  getShowcaseDetails,
  createShowcase,
  addShowcasePost,
  getMyPosts,
  getDPStatistics,
  getShowcaseCards,
} from "../../redux/actions/showcase";
import { staticFiles } from "../../components/Helpers/Static";
import { setUserCover, loadVBE, getUserTheme } from "../../redux/actions/auth";
import axios from "axios";
import { apiMainUrl, apiUrl, serverUrl } from "../../components/Helpers/Config";
import { ActiveSpanColor } from "../Theme";
import CameraIcon from "../../common/images-new/camera-icon.png";
import Tooltip from "@mui/material/Tooltip";
import PinnedReflectionIcon from "../../common/images-new/pinnedReflection.png";
import InfoIconRed from "../../common/images-new/info-icon-red.png";
import InfoIcon from "@mui/icons-material/Info";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import PaletteOutlinedIcon from "@mui/icons-material/PaletteOutlined";
import LinkOutlinedIcon from "@mui/icons-material/LinkOutlined";
import { getImagePools, getSystemThemes } from "../../redux/actions/auth";
import Modal from "../../components/Modal/ModelNewPopup";
import GetAppOutlinedIcon from "@mui/icons-material/GetAppOutlined";
import ModalEditCover from "../../components/Modal/ModalEditCover";
import ModalProfile from "../../components/Modal/ModalProfile";
import bgImage from "../../common/images-new/status-bg1.png";
import NoProfilePhoto from "../../common/images-new/no-profile-pic.png";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import RichTextReadMore from "../../components/Editor/RichTextReadMore";
import { FaRegCommentDots } from "react-icons/fa";
import ModalShowcaseLink from "../../components/Modal/ModalShowcaseLink";
import ModalExport from "../../components/Modal/ModalExport";
import { tokenAuthorize, removeIframe } from "../../components/Helpers/Common";
import { toast } from "react-toastify";
import { getAnalyticsModuleCardDetails } from "../../redux/actions/analyticsActions";
import { CommonLoader } from "../../components/Button/Loader";
import { useTheme } from "styled-components";
const DEFAULT_COVER = staticFiles.coverDefault;

const UserProfile = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const userProfile = useSelector((state) => state.auth.user);
  const showcases = useSelector((state) => state.showcase.showcases);
  const myPosts = useSelector((state) => state.showcase.myPosts);
  const competency_status = useSelector((state) => state.showcase.competency);
  const dpStatistics = useSelector((state) => state.showcase.dpStatistics);
  const showcaseCards = useSelector((state) => state.showcase.showcaseCards);
  const [aboutPost, setAboutPost] = useState(null);
  const [teachingPhil, setTeachingPhil] = useState(null);
  const [postOptions, setPostOptions] = useState([]);
  const [coverImage, setCoverImage] = useState(userProfile?.cover);
  const [coverImageFile, setCoverImageFile] = useState(null);
  const coverImageRef = useRef();
  const [isEmailVisible, SetEmailVisible] = useState(false);
  const userTheme = useSelector((state) => state.auth.theme);

  useEffect(() => {
    axios
      .get(serverUrl.ProfileSettings)
      .then((res) => {
        if (res.status === 200) {
          SetEmailVisible(res?.data?.results?.display_email);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  }, []);
  const [pinnedReflection, setpinnedReflection] = useState("");

  const [buttonDisabled, setButtonDisabled] = useState({
    createAboutShowcase: false,
    createStatusShowcase: false,
  });
  const [toggle, setToggle] = useState(false);
  useEffect(() => {
    handlePinnedReflection();
    dispatch(getDPStatistics());
    dispatch(getUserTheme());
    dispatch(getShowcaseCards());
    dispatch(getAnalyticsModuleCardDetails());
    localStorage.removeItem("journalSave");
    if (sessionStorage.getItem("profilePath") == "true") {
      const data = sessionStorage.getItem("profileCurrentPath");
      if (data?.includes("/digitalportfolio2")) {
        const path = data?.split("/digitalportfolio2")[1];
        history.push(path);
      } else {
        history.push(sessionStorage.getItem("profileCurrentPath"));
      }
    }
  }, []);

  const handlePinnedReflection = () => {
    return axios
      .get(serverUrl.Pinned_Reflection)
      .then((resp) => {
        if (resp.status === 200) {
          setpinnedReflection(resp?.data);
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  useEffect(() => {
    if (coverImageFile) {
      const objectURL = URL.createObjectURL(coverImageFile);
      setCoverImage(objectURL);
      return () => URL.revokeObjectURL(objectURL);
    }
  }, [coverImageFile]);

  const handleCoverImageChange = (e) => {
    const fileObj = e.target.files[0];
    if (!fileObj) return;
    setCoverImageFile(fileObj);

    const formData = new FormData();
    formData.append("file", fileObj);

    axios
      .post(apiUrl + "upload/cover", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(setUserCover(apiMainUrl + resp.data.photo));
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  useEffect(() => {
    dispatch(getShowcases());
    dispatch(getShowcaseDetails());
    // dispatch(loadVBE());
  }, [dispatch]);

  useEffect(() => {
    const scAbout = showcases
      .filter(
        (scItem) => scItem.name.toLowerCase() === "about me" && scItem.published
      )
      .pop();

    const pinnedData = pinnedReflection
      ? pinnedReflection
      : "teaching philosophy";
    const scTeachPhil = showcases
      .filter(
        (scItem) =>
          scItem.name.toLowerCase() === pinnedData?.toLowerCase() &&
          scItem.published
      )
      .pop();

    if (scAbout && scAbout.posts && scAbout.posts.length > 0) {
      //PROD Issue
      let sortSCPost = scAbout.posts.sort((a, b) => {
        if (a.order === null) return 1;
        if (b.order === null) return -1;
        return b.order - a.order;
      });
      setAboutPost(sortSCPost[0]);
      //setAboutPost(scAbout.posts[0])
    } else {
      setAboutPost(null);
    }

    if (scTeachPhil && scTeachPhil.posts && scTeachPhil.posts.length > 0) {
      const scTeachPhils = scTeachPhil.posts.sort(function (a, b) {
        return b.order - a.order;
      });
      setTeachingPhil(scTeachPhils[0]);
    } else setTeachingPhil(null);
  }, [showcases]);

  const profile = {
    name: userProfile ? userProfile.fullname : "",
    email: userProfile
      ? userProfile.display_email && userProfile.display_email.length > 0
        ? userProfile.display_email
        : userProfile.email
      : "",
    programme: userProfile ? userProfile.programme : "",
    photo: userProfile ? userProfile.photo : hmenu_user,
    user_type: userProfile ? userProfile.user_type : "",
    program_category: userProfile ? userProfile.programme_category : "",
  };

  // use for modal create showcase
  const [showCreateShowcase, setShowCreateShowcase] = useState(false);
  const [showcaseName, setShowcaseName] = useState("");
  const [showcaseNameEmpty, setShowcaseNameEmpty] = useState(false);
  const [showcaseNameExist, setShowcaseNameExist] = useState(false);
  const newShowcaseStatus = useSelector((state) => state.showcase.new);

  // use for modal create about showcase
  const [showCreateAboutMeShowcase, setShowCreateAboutMeShowcase] =
    useState(false);
  const [aboutShowcaseExist, setAboutShowcaseExist] = useState(false);

  const [showCreateStatusShowcase, setShowCreateStatusShowcase] =
    useState(false);
  const [statusShowcaseExist, setStatusShowcaseExist] = useState(false);

  const openModalStatusShowcase = () => {
    const pinnedData = pinnedReflection
      ? pinnedReflection
      : "teaching philosophy";
    const scTeachPhil = showcases.filter(
      (scItem) => scItem.name.toLowerCase() === pinnedData?.toLowerCase()
    );
    if (scTeachPhil.length > 0) {
      Swal.fire({
        heightAuto: false,
        title: "Showcase Exists",
        html:
          "Looks like you already have <b>" +
          pinnedData +
          "</b> showcase. Please make sure the showcase is <b>published</b> and add a post to it.",
        icon: "info",
      });
    } else {
      setShowCreateStatusShowcase(true);
      setStatusShowcaseExist(false);
      setButtonDisabled({ ...buttonDisabled, createStatusShowcase: false });
    }
  };

  // use for modal add about post
  const [showAddAboutPost, setShowAddAboutPost] = useState(false);
  const [selectedAboutPost, setSelectedAboutPost] = useState(0);
  const [addAboutPostFailed, setAddAboutPostFailed] = useState(false);

  const openModalAboutPost = () => {
    const scAbout = showcases.filter(
      (scItem) => scItem.name.toLowerCase() === "about me"
    );
    const aboutPostsId =
      scAbout && scAbout.length > 0
        ? scAbout[0].posts.map((post) => post.id)
        : 0;
    const aboutPostOptions = myPosts.filter(
      (post) => !aboutPostsId.includes(post.reflection_id)
    );
    if (scAbout.length > 0) {
      setSelectedAboutPost(0);
      setShowAddAboutPost(true);
      dispatch(getMyPosts());
      setPostOptions(aboutPostOptions);
    } else {
      Swal.fire({
        heightAuto: false,
        title: "Cannot add a post",
        html: "Please create a showcase named <b>About Me</b>",
        icon: "info",
      });
    }
  };
  //PROD Issue
  const handleAddAboutPost = () => {
    const scAbout = showcases.filter(
      (scItem) => scItem.name.toLowerCase() === "about me"
    );
    if (selectedAboutPost !== 0) {
      dispatch(
        addShowcasePost(
          scAbout[0].id,
          selectedAboutPost,
          scAbout[0]?.posts?.length
        )
      ).then(() => {
        dispatch(getShowcases());
      });
    }
  };

  // use for modal add status (teaching philosophy) post
  const [showAddStatusPost, setShowAddStatusPost] = useState(false);
  const [selectedStatusPost, setSelectedStatusPost] = useState(0);
  const [addStatusPostFailed, setAddStatusPostFailed] = useState(false);

  const openModalStatusPost = () => {
    const pinnedData = pinnedReflection
      ? pinnedReflection?.toLowerCase()
      : "teaching philosophy";
    const scTeachPhil = showcases.filter(
      (scItem) => scItem.name.toLowerCase() === pinnedData
    );
    const showcasePostIds = scTeachPhil.map((post) => post.id);
    const postOptionsData = myPosts.filter(
      (post) => !showcasePostIds.includes(post.reflection_id)
    );

    if (scTeachPhil.length > 0) {
      setSelectedStatusPost(0);
      setShowAddStatusPost(true);
      dispatch(getMyPosts());
      setPostOptions(postOptionsData);
    } else {
      let data = pinnedReflection ? pinnedReflection : "Teaching Philosophy";
      Swal.fire({
        heightAuto: false,
        title: "Cannot add a post",
        // html: 'Please create a showcase named <b>Teaching Philosophy</b>',
        html: "Please create a showcase named <b>" + data + "</b>",
        icon: "info",
      });
    }
  };

  const getTabId = (tabName) => {
    const targetShowcase = showcases.filter(
      (scItem) => scItem.name.toLowerCase() === tabName.toLowerCase()
    );
    if (targetShowcase.length > 0) {
      return targetShowcase[0].id;
    } else return 0;
  };
  //PROD Issue
  const handleAddStatusPost = () => {
    const pinnedData = pinnedReflection
      ? pinnedReflection
      : "teaching philosophy";
    const scTeachPhil = showcases.filter(
      (scItem) => scItem.name.toLowerCase() === pinnedData?.toLowerCase()
    );
    if (selectedStatusPost !== 0) {
      dispatch(
        addShowcasePost(
          scTeachPhil[0].id,
          selectedStatusPost,
          scTeachPhil[0]?.posts?.length
        )
      ).then(() => {
        dispatch(getShowcases());
      });
    }
  };
  useEffect(() => {
    if (showAddStatusPost) {
      dispatch(getMyPosts());
    }
  }, [showAddStatusPost]);

  const handleNewShowcase = (showcaseName) => {
    setShowcaseNameEmpty(false);
    dispatch(createShowcase(showcaseName, userProfile?.learner_profile_id));
    toast.success("New showcase created successfully");
  };

  useEffect(() => {
    if (showCreateShowcase && !newShowcaseStatus.isLoading) {
      if (newShowcaseStatus.isSuccess) {
        setShowCreateShowcase(false);
      } else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
        setShowcaseNameEmpty(true);
      }
    }

    if (showCreateAboutMeShowcase && !newShowcaseStatus.isLoading) {
      if (newShowcaseStatus.isSuccess) {
        setShowCreateAboutMeShowcase(false);
      }
    }

    if (showCreateStatusShowcase && !newShowcaseStatus.isLoading) {
      if (newShowcaseStatus.isSuccess) {
        setShowCreateStatusShowcase(false);
      }
    }

    if (showAddAboutPost && !newShowcaseStatus.isLoading) {
      if (newShowcaseStatus.isSuccess) {
        setShowAddAboutPost(false);
        setAddAboutPostFailed(false);
      } else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
        setAddAboutPostFailed(true);
      }
    }

    if (showAddStatusPost && !newShowcaseStatus.isLoading) {
      if (newShowcaseStatus.isSuccess) {
        setShowAddStatusPost(false);
        setAddStatusPostFailed(false);
      } else if (!newShowcaseStatus.isSuccess && newShowcaseStatus.errors) {
        setAddStatusPostFailed(true);
      }
    } else {
    }
  }, [newShowcaseStatus]);

  const [isPublic, setIsPublic] = useState(true);
  const handlePrivatePublic = (data) => {
    if (isPublic != data) {
      setIsPublic(!isPublic);
    }
  };
  const systemThemes = useSelector((state) => state.auth.systemTheme);

  useEffect(() => {
    dispatch(getSystemThemes());
  }, []);

  const handleLikePost = (postId, isLiked) => {
    axios
      .post(serverUrl.ReflectionPost + "/like", {
        reflection_id: postId,
        like: isLiked,
      })
      .then((resp) => {
        if (resp.status === 200) {
          dispatch(getShowcases());
        }
      })
      .catch((err) => {
        tokenAuthorize(err?.response?.status);
        console.log(err);
      });
  };

  const [currentThemeId, setCurrentThemeId] = useState(0);

  useEffect(() => {
    if (userTheme?.theme_id) {
      setCurrentThemeId(userTheme?.theme_id);
    }
  }, [userTheme]);

  const [isOpenModelTheme, setIsOpenModelTheme] = useState(false);
  const modalPopupTheme = (
    <div>
      <div className="pt-3">
        {systemThemes?.length !== 0 ? (
          <div className="flex flex-col justify-center">
            <div className="overflow-auto max-h-96">
              {systemThemes?.length > 0 ? (
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 p-2">
                  <div
                    className={`row cursor-pointer backGroundColor p-4 rounded-lg ${currentThemeId == 0 || userTheme == "default theme"
                        ? "borderBlack"
                        : ""
                      }`}
                    onClick={() => handleChangeTheme(0, 0)}
                  >
                    <div className="col-12 pb-2">
                      <p class="truncate blackColor font-semibold text-base">
                        {"Default theme"}
                      </p>
                    </div>
                    <div className="grid grid-cols-8 col-12 cardBackgroundColor p-1 rounded-md">
                      <div
                        className="color-div-theme rounded-l-md"
                        style={{ backgroundColor: `#F3F6F6` }}
                      ></div>
                      <div
                        className="color-div-theme"
                        style={{ backgroundColor: `#2084D4` }}
                      ></div>
                      <div
                        className="color-div-theme"
                        style={{ backgroundColor: `#31658e` }}
                      ></div>
                      <div
                        className="color-div-theme"
                        style={{ backgroundColor: `white` }}
                      ></div>
                      <div
                        className="color-div-theme"
                        style={{ backgroundColor: `black` }}
                      ></div>
                      <div
                        className="color-div-theme"
                        style={{ backgroundColor: `#9ca3af` }}
                      ></div>
                      <div
                        className="color-div-theme"
                        style={{ backgroundColor: `#969696` }}
                      ></div>
                      <div
                        className="color-div-theme rounded-r-md"
                        style={{ backgroundColor: `#dc2626` }}
                      ></div>
                    </div>
                  </div>
                  {systemThemes?.map((i) => (
                    <>
                      <div
                        className={`row cursor-pointer backGroundColor p-4 rounded-lg  ${currentThemeId == i.id ? "borderBlack" : ""
                          }`}
                        onClick={() => handleChangeTheme(i.id, i)}
                      >
                        <div className="col-12 pb-2">
                          <p class="truncate blackColor font-semibold text-base">
                            {i?.theme_name}
                          </p>
                        </div>
                        <div className="grid grid-cols-8 col-12 cardBackgroundColor p-1 rounded-md">
                          <div
                            className="color-div-theme rounded-l-md"
                            style={{ backgroundColor: `${i.color1}` }}
                          ></div>
                          <div
                            className="color-div-theme"
                            style={{ backgroundColor: `${i.color2}` }}
                          ></div>
                          <div
                            className="color-div-theme"
                            style={{ backgroundColor: `${i.color3}` }}
                          ></div>
                          <div
                            className="color-div-theme"
                            style={{ backgroundColor: `${i.color4}` }}
                          ></div>
                          <div
                            className="color-div-theme"
                            style={{ backgroundColor: `${i.color5}` }}
                          ></div>
                          <div
                            className="color-div-theme"
                            style={{ backgroundColor: `${i.color6}` }}
                          ></div>
                          <div
                            className="color-div-theme"
                            style={{ backgroundColor: `${i.color7}` }}
                          ></div>
                          <div
                            className="color-div-theme rounded-r-md"
                            style={{ backgroundColor: `${i.color8}` }}
                          ></div>
                        </div>
                      </div>
                    </>
                  ))}
                </div>
              ) : (
                <div className="grid grid-cols-1 p-5">
                  <div class="font-semibold">No Themes Found</div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="w-full flex items-center justify-center h-full">
            <CommonLoader />
          </div>
        )}
      </div>
    </div>
  );
  const handleChangeTheme = (i, data) => {
    setCurrentThemeId(i);
    let profileData = { profile_id: userProfile?.learner_profile_id };
    if (i === 0) {
      dispatch({
        type: "GET_USER_DEFAULT_THEME",
        payload: "",
      });
      dispatch({
        type: "GET_USER_THEME",
        payload: "",
      });
    } else {
      dispatch({
        type: "GET_USER_THEME",
        payload: data,
      });
    }
    if (i >= 0) {
      axios
        .put(serverUrl.putSystemTheme + i, profileData)
        .then((resp) => {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Theme has been changed successfully.",
          });
        })
        .catch((err) => {
          tokenAuthorize(err?.response?.status);
          console.log(err);
        });
    }
  };

  const [isOpenModalEditTeaching, setIsEditTeaching] = useState(false);

  const [isOpenModalEditBanner, setIsEditBanner] = useState(false);
  const [editCoverImage, seteditCoverImage] = useState("");

  useEffect(() => {
    if (editCoverImage) {
      let dataImage = {
        file: editCoverImage,
      };
      if (editCoverImage != "") {
        axios
          .post(
            serverUrl.ProfileCover +
            "?profile_id=" +
            userProfile?.learner_profile_id,
            dataImage
          )
          .then((resp) => {
            if (resp.status === 200) {
              dispatch(setUserCover(resp.data.photo));
              setIsEditBanner(false);
            }
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            console.log(err);
            setIsEditBanner(false);
          });
      }
    }
  }, [editCoverImage]);

  const [showProfile, setShowProfile] = useState(false);
  const [profilePhoto, setProfilePhoto] = useState(profile.photo);
  const [profilePhotoFile, setProfilePhotoFile] = useState(null);
  const profilePhotoRef = useRef();

  useEffect(() => {
    if (profilePhotoFile) {
      const objectURL = URL.createObjectURL(profilePhotoFile);
      setProfilePhoto(objectURL);
      return () => URL.revokeObjectURL(objectURL);
    }
  }, [profilePhotoFile]);

  const handleFeatImgChange = (e) => {
    const fileObject = e.target.files[0];
    if (!fileObject) return;
    setProfilePhotoFile(fileObject);
    setShowProfile(true);
  };

  const handleProfileUpload = () => {
    profilePhotoRef.current.value = "";
    profilePhotoRef.current.click();
  };

  const [showGetLink, setShowGetLink] = useState(false);
  const [showExport, setShowExport] = useState(false);

  return (
    <>
      <PageWrapper isShowCase={true}>
        <div className="px-5 md:px-10 lg:px-10 xl:px-10 content containerMaxWidth">
          {/* Theme */}
          {isOpenModelTheme && (
            <Modal
              isOpen={isOpenModelTheme}
              onClose={() => setIsOpenModelTheme(false)}
              header="Change theme"
            >
              {modalPopupTheme}
            </Modal>
          )}
          {/* Pinned Reflection Cover Image */}
          {isOpenModalEditTeaching && (
            <ModalEditCover
              showModalEditCover={isOpenModalEditTeaching}
              setshowModalEditCover={setIsEditTeaching}
              editCover={false}
              editBanner={true}
              editPinned={true}
            />
          )}
          {/* Cover Image */}
          {isOpenModalEditBanner && (
            <ModalEditCover
              showModalEditCover={isOpenModalEditBanner}
              setshowModalEditCover={setIsEditBanner}
              editCover={true}
              editBanner={false}
              seteditCoverImage={seteditCoverImage}
            />
          )}
          {/* Profile Image */}
          {showProfile && (
            <ModalProfile
              show={showProfile}
              setShow={setShowProfile}
              imgSrc={profilePhoto}
              editCover={false}
              editBanner={false}
            />
          )}
          {/* Showcase link */}
          {showGetLink && (
            <ModalShowcaseLink
              show={showGetLink}
              handleClose={() => setShowGetLink(false)}
            />
          )}
          {/* Modal Export */}
          {showExport && (
            <ModalExport show={showExport} setShow={setShowExport} />
          )}
          {/* Create teaching Philosophy */}
          {showAddStatusPost && (
            <ModalAddPost
              show={showAddStatusPost}
              handleClose={() => setShowAddStatusPost(false)}
              onClick={handleAddStatusPost}
              dropdownOption={postOptions}
              value={selectedStatusPost}
              onChange={(e) => setSelectedStatusPost(e.target.value)}
              addPostLoader={newShowcaseStatus.isLoading}
              failed={addStatusPostFailed}
              tabId={getTabId(
                pinnedReflection
                  ? pinnedReflection?.toLowerCase()
                  : "teaching philosophy"
              )}
            />
          )}
          {showCreateStatusShowcase && (
            <ModalCreateShowcase
              handleClose={() => setShowCreateStatusShowcase(false)}
              show={showCreateStatusShowcase}
              onClick={() =>
                handleNewShowcase(
                  pinnedReflection ? pinnedReflection : "Teaching Philosophy"
                )
              }
              showcaseName={
                pinnedReflection ? pinnedReflection : "Teaching Philosophy"
              }
              showcaseLoader={newShowcaseStatus.isLoading}
              inputDisabled={true}
              showcaseNameExist={statusShowcaseExist}
              buttonDisabled={buttonDisabled.createStatusShowcase}
            />
          )}
          <div className="w-full">
            <div className="mx-auto">
              <div className="rounded-lg overflow-hidden cardBackgroundColor">
                {/* Banner Section */}
                <div
                  className="relative h-40 sm:h-52 md:h-56 lg:h-64 bg-gradient-to-r from-blue-900 via-black to-red-700 bg-cover bg-no-repeat"
                  style={{
                    backgroundImage: `url(${userProfile?.cover != "" && userProfile?.cover != null
                        ? userProfile.cover
                        : DEFAULT_COVER
                      })`,
                  }}
                >
                  <div
                    className="absolute top-4 left-4 CameraIcon rounded-full p-2.5 shadow-md cursor-pointer hover:bg-gray-100"
                    onClick={() => setIsEditBanner(true)}
                  >
                    <Tooltip title={"Edit cover image"} placement="top" arrow>
                      <img src={CameraIcon} className="cursor-pointer" />
                    </Tooltip>
                  </div>
                </div>

                {/* Content Wrapper */}
                <div className="relative px-4 pb-6">
                  {/* Profile Image */}
                  <div className="w-full flex justify-center md:block">
                    <div className="relative -mt-12 md:left-6 md:absolute md:transform md:-translate-y-24 z-10">
                      <input
                        className="hidden"
                        ref={profilePhotoRef}
                        type="file"
                        accept="image/gif, image/jpeg, image/jpg, image/png"
                        onChange={handleFeatImgChange}
                      />
                      <img
                        src={profile?.photo ? profile?.photo : NoProfilePhoto} // Replace this with your image path
                        alt="Profile"
                        className={`h-56 w-56 rounded-lg object-cover ${profile?.photo ? "" : "bg-gray"
                          } `}
                      />
                      <div
                        className="absolute bottom-2 right-2 CameraIcon rounded-full p-2.5 shadow-md cursor-pointer hover:bg-gray-100"
                        onClick={() => handleProfileUpload()}
                      >
                        <Tooltip
                          title={"Edit profile image"}
                          placement="top"
                          arrow
                        >
                          <img src={CameraIcon} className="cursor-pointer" />
                        </Tooltip>
                      </div>
                    </div>
                  </div>

                  {/* Main Content */}
                  <div className="mt-4 md:pl-64 lg:pl-64">
                    {/* Metadata Grid */}
                    <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-5 gap-2 md:gap-6 text-sm mt-6">
                      {/* User Info */}
                      <div className="text-center sm:text-left">
                        <h2 className="text-xl blackColor font-bold">
                          {userProfile ? userProfile.fullname : ""}
                        </h2>
                        {isEmailVisible && (
                          <p className="text-sm font-medium lightColor">
                            {userProfile
                              ? userProfile.display_email &&
                                userProfile.display_email.length > 0
                                ? userProfile.display_email
                                : userProfile.email
                              : ""}
                          </p>
                        )}
                        <div className="flex justify-center sm:justify-start mt-2 text-gray-600">
                          <div className="border rounded-md px-2.5 py-1 flex gap-1.5 items-center w-fit">
                            <Tooltip title={"Get link"} placement="top" arrow>
                              <LinkOutlinedIcon
                                fontSize="small"
                                className="cursor-pointer blueColor w-4 h-4 rotate-z-150"
                                onClick={() => setShowGetLink(true)}
                              />
                            </Tooltip>
                            <Tooltip title={"Export"} placement="top" arrow>
                              <GetAppOutlinedIcon
                                fontSize="small"
                                className="cursor-pointer blueColor w-5 h-5"
                                onClick={() => setShowExport(true)}
                              />
                            </Tooltip>
                            <Tooltip
                              title={"Change theme"}
                              placement="top"
                              arrow
                            >
                              <PaletteOutlinedIcon
                                fontSize="small"
                                className="cursor-pointer blueColor w-4 h-4"
                                onClick={() => setIsOpenModelTheme(true)}
                              />
                            </Tooltip>
                          </div>
                        </div>
                      </div>

                      {/* Programme Info */}
                      <div>
                        <p className="lightColor text-sm pb-2">Programme</p>
                        <p className="blackColor font-medium text-base">
                          {userProfile ? userProfile.programme_category : ""}
                        </p>
                      </div>

                      {/* User Role */}
                      <div>
                        <p className="lightColor text-sm pb-2">User Role</p>
                        <p className="blackColor font-medium text-base">
                          {userProfile ? userProfile.user_type : ""}
                        </p>
                      </div>
                      {/* DP Statistics */}
                      <div className="sm:col-span-2">
                        <p className="lightColor font-medium pb-3">
                          My DP Analytics
                        </p>
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 cardBackgroundColor rounded">
                          <div
                            className="cursor-pointer justify-self-center md:justify-self-start"
                            onClick={() => history.push("/community/shared")}
                          >
                            <div className="flex gap-1 justify-center">
                              <p className="DPStatisticsCount font-bold">
                                {dpStatistics?.total_shared_count
                                  ? dpStatistics?.total_shared_count
                                  : "0"}
                              </p>
                              <Tooltip
                                title={
                                  "Total number of your reflections shared"
                                }
                                placement="top"
                                arrow
                              >
                                <span>
                                  <InfoIcon className="cursor-pointer primaryIcon info-icon" />
                                </span>
                              </Tooltip>
                            </div>
                            <div className="text-sm font-medium blackColor mt-2 text-center">
                              Reflections Shared
                            </div>
                          </div>
                          <div
                            className="cursor-pointer justify-self-center md:justify-self-start"
                            onClick={() => history.push("/tasks")}
                          >
                            <div className="flex gap-1 justify-center">
                              <p className="DPStatisticsCount font-bold">
                                {dpStatistics?.outstanding_DP_task_count
                                  ? dpStatistics?.outstanding_DP_task_count
                                  : "0"}
                              </p>
                              <Tooltip
                                title={"Total number of your on-going DP Task"}
                                placement="top"
                                arrow
                              >
                                <span>
                                  <InfoIcon className="cursor-pointer primaryIcon info-icon" />
                                </span>
                              </Tooltip>
                            </div>
                            <div className="text-sm font-medium blackColor mt-2 text-center">
                              Outstanding DP Tasks
                            </div>
                          </div>
                          <div
                            className="cursor-pointer justify-self-center md:justify-self-start"
                            onClick={() => history.push("/journal")}
                          >
                            <div className="flex gap-1 justify-center">
                              <p className="DPStatisticsCount font-bold">
                                {dpStatistics?.reflections_written
                                  ? dpStatistics?.reflections_written
                                  : "0"}
                              </p>
                              <Tooltip
                                title={
                                  "Total number of your reflection written"
                                }
                                placement="top"
                                arrow
                              >
                                <span>
                                  <InfoIcon className="cursor-pointer primaryIcon info-icon" />
                                </span>
                              </Tooltip>
                            </div>
                            <div className="text-center text-sm font-medium blackColor mt-2">
                              Reflections Written
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="w-full mt-4">
            <div className="space-y-4 lg:space-y-0 lg:grid lg:grid-cols-4 lg:gap-4">
              {/* Left Column */}
              <div className="space-y-4">
                <div className="cardBackgroundColor p-6 rounded-lg myshowcaseCardHeight flex flex-col">
                  <h4 className="text-xl blackColor text-center font-bold mb-1">
                    Showcase Readiness
                  </h4>
                  <p className="DPStatisticsCount font-bold text-center blueColor mb-1">
                    {showcaseCards?.results?.showcase_readiness
                      ?.published_showcases || 0}
                  </p>
                  <p className="text-lg font-medium text-center lightColor mb-2 ">
                    Published Showcases
                  </p>
                  <div className="px-2 xl:px-5 mt-2">
                    <div className="flex justify-between my-2">
                      <p className="flex items-center text-base lightColor">
                        Profile Picture
                        <Tooltip
                          title={
                            "Upload your profile picture to complete this step."
                          }
                          placement="top"
                          arrow
                        >
                          <span>
                            <InfoIcon className="cursor-pointer  ml-1 secondaryIcon info-icon-width -mt-2" />
                          </span>
                        </Tooltip>
                      </p>
                      {showcaseCards?.results?.showcase_readiness
                        ?.profile_picture === 1 ? (
                        <CheckCircleIcon className="primaryIcon" />
                      ) : (
                        <CheckCircleIcon className="secondaryIcon" />
                      )}
                    </div>
                    <div className="flex justify-between my-2">
                      <p className="flex items-center text-base lightColor">
                        About Me
                        <Tooltip
                          title={
                            "Add one post to your “About Me” showcase and publish the showcase."
                          }
                          placement="top"
                          arrow
                        >
                          <span>
                            <InfoIcon className="cursor-pointer  ml-1 secondaryIcon info-icon-width -mt-2" />
                          </span>
                        </Tooltip>
                      </p>
                      {showcaseCards?.results?.showcase_readiness?.about_me ===
                        1 ? (
                        <CheckCircleIcon className="primaryIcon" />
                      ) : (
                        <CheckCircleIcon className="secondaryIcon" />
                      )}
                    </div>
                    <div className="flex justify-between my-2">
                      <p className="flex items-center text-base lightColor">
                        Pinned Reflection
                        <Tooltip
                          title={
                            "The pinned reflection is on the right of this card. Make sure you have a showcase eg. “Teaching Philosophy” and add a post there. After you publish the showcase, the topmost post will be pinned to your profile page."
                          }
                          placement="top"
                          arrow
                        >
                          <span>
                            <InfoIcon className="cursor-pointer  ml-1 secondaryIcon info-icon-width -mt-2" />
                          </span>
                        </Tooltip>
                      </p>
                      {showcaseCards?.results?.showcase_readiness
                        ?.pinned_reflection === 1 ? (
                        <CheckCircleIcon className="primaryIcon" />
                      ) : (
                        <CheckCircleIcon className="secondaryIcon" />
                      )}
                    </div>
                  </div>
                  <p className="text-sm lightColor text-center mt-auto">
                    {showcaseCards?.results?.showcase_readiness?.description ||
                      ""}
                  </p>
                </div>
              </div>

              <div className="md:col-span-3 space-y-4">
                {/* Teaching Philosophy */}
                <div className="space-y-4 ">
                  <div className="relative rounded-lg myshowcaseCardHeight overflow-hidden">
                    {teachingPhil ? (
                      <>
                        <div
                          className="cursor-pointer"
                          onClick={() =>
                            history.push(`/post/${teachingPhil?.id}`)
                          }
                        >
                          <div
                            className="absolute inset-0 bg-cover myshowcaseCardHeight rounded-lg bg-no-repeat bg-center"
                            style={{
                              backgroundImage: `url(${userProfile?.pinned_reflection_image
                                ? userProfile?.pinned_reflection_image
                                : bgImage
                                })`,
                            }}
                          ></div>
                          <div
                            className="absolute z-10 top-2 right-2 CameraIcon rounded-full p-2.5 shadow-md cursor-pointer hover:bg-gray-100"
                            onClick={(e) => {
                              e.stopPropagation();
                              setIsEditTeaching(true);
                            }}
                          >
                            <Tooltip
                              title={"Edit pinned reflection image"}
                              placement="top"
                              arrow
                            >
                              <img
                                src={CameraIcon}
                                className="cursor-pointer"
                              />
                            </Tooltip>
                          </div>
                          <p className="text-xl w-full text-center py-2 absolute font-bold text-black">
                            {pinnedReflection
                              ? pinnedReflection
                              : "Teaching Philosophy"}
                          </p>
                          <div className="w-full blurText">
                            <p className="text-base font-semibold w-full text-black">
                              <RichTextReadMore
                                htmlContent={removeIframe(
                                  teachingPhil?.content
                                )}
                                maxLines={4}
                                postId={teachingPhil?.id}
                              />
                            </p>
                          </div>

                          <div
                            className="absolute bottom-2 right-0 flex float-right pr-6 justify-end items-center mt-3 lightColor text-sm"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div
                              className="flex items-center mr-3 gap-0.5 cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleLikePost(
                                  teachingPhil?.id,
                                  teachingPhil?.liked === 1 ? 0 : 1
                                );
                              }}
                            >
                              {teachingPhil?.liked ? (
                                <ThumbUpAltIcon
                                  fontSize="small"
                                  className={`likeIcon primaryIcon`}
                                />
                              ) : (
                                <ThumbUpOffAltIcon
                                  fontSize="small"
                                  className={`likeIcon secondaryIcon`}
                                />
                              )}
                              <span className="lightColor">
                                {teachingPhil?.likes?.count} Likes
                              </span>
                            </div>
                            <div
                              className="flex items-center gap-0.5 cursor-pointer"
                              onClick={(e) => {
                                e.stopPropagation();
                                history.push("/post/" + teachingPhil?.id);
                              }}
                            >
                              <FaRegCommentDots
                                className={`w-4 h-4 secondaryIcon`}
                              />
                              <span className="lightColor">
                                {teachingPhil?.comments} Comments
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="flex flex-row justify-center items-center space-x-5 myshowcaseCardHeight cardBackgroundColor px-3 sm:px-10">
                          {/* <img src={PAPER_ICON} alt="teaching philosophy" /> */}
                          <img
                            src={PinnedReflectionIcon}
                            alt="teaching philosophy"
                            className=""
                          />
                          <p className="lightColor">
                            It looks like you have not set your teaching
                            philosophy. Let's&nbsp;
                            <ActiveSpanColor
                              onClick={() => openModalStatusShowcase()}
                              className="cursor-pointer blueColor hover:underline"
                            >
                              create a showcase
                            </ActiveSpanColor>{" "}
                            named "
                            {pinnedReflection
                              ? pinnedReflection
                              : "Teaching Philosophy"}
                            ",&nbsp;
                            <ActiveSpanColor
                              onClick={() => openModalStatusPost()}
                              className="cursor-pointer blueColor hover:underline"
                            >
                              add a post
                            </ActiveSpanColor>{" "}
                            and make sure it is <b>published</b>.
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <ShowcaseContainer profile={profile} data={showcases} />
          </div>
        </div>
        <MyValuesCompetencis />
      </PageWrapper >
    </>
  );
};

export default UserProfile;
